/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Toggle_Filters_LabelInputs */

const en_manual_qc_toggle_filters_label = /** @type {(inputs: Manual_Qc_Toggle_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle filters`)
};

const fr_manual_qc_toggle_filters_label = /** @type {(inputs: Manual_Qc_Toggle_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher/masquer les filtres`)
};

const de_manual_qc_toggle_filters_label = /** @type {(inputs: Manual_Qc_Toggle_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter umschalten`)
};

const it_manual_qc_toggle_filters_label = /** @type {(inputs: Manual_Qc_Toggle_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva i filtri`)
};

const ru_manual_qc_toggle_filters_label = /** @type {(inputs: Manual_Qc_Toggle_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить фильтры`)
};

const es_manual_qc_toggle_filters_label = /** @type {(inputs: Manual_Qc_Toggle_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar o desactivar filtros`)
};

const zh_cn2_manual_qc_toggle_filters_label = /** @type {(inputs: Manual_Qc_Toggle_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换筛选器`)
};

const ja_manual_qc_toggle_filters_label = /** @type {(inputs: Manual_Qc_Toggle_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フィルターを切り替える`)
};

const hi_manual_qc_toggle_filters_label = /** @type {(inputs: Manual_Qc_Toggle_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़िल्टर टॉगल करें`)
};

const pt_pt2_manual_qc_toggle_filters_label = /** @type {(inputs: Manual_Qc_Toggle_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar filtros`)
};

/**
* | output |
* | --- |
* | "Toggle filters" |
*
* @param {Manual_Qc_Toggle_Filters_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_toggle_filters_label = /** @type {((inputs?: Manual_Qc_Toggle_Filters_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Toggle_Filters_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_toggle_filters_label(inputs)
	if (locale === "de") return de_manual_qc_toggle_filters_label(inputs)
	if (locale === "it") return it_manual_qc_toggle_filters_label(inputs)
	if (locale === "ru") return ru_manual_qc_toggle_filters_label(inputs)
	if (locale === "es") return es_manual_qc_toggle_filters_label(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_toggle_filters_label(inputs)
	if (locale === "ja") return ja_manual_qc_toggle_filters_label(inputs)
	if (locale === "hi") return hi_manual_qc_toggle_filters_label(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_toggle_filters_label(inputs)
	return en_manual_qc_toggle_filters_label(inputs)
});